module.exports = __webpack_public_path__ + "img/powerpoint.b68eb231.png";